import React from 'react';
import { IconButton } from './IconContainer';

const SupportIcon = (props) => {
    const iconProps = {
        ariaLabel: 'icon: support',
        color: "var(--sp-grey-blue-color)",
        hoverColor: "var(--sp-dark-grey-blue-color)",
        background: "var(--sp-light-blue-color)",
        hoverBackground: "var(--sp-light-blue-color)",
        ...props
    };

    return (
        <IconButton { ...iconProps }>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.6667 0.666656C15.1267 0.666656 15.5 1.03999 15.5 1.49999V4.63082L8.00083 12.1308L7.99583 15.6625L11.5342 15.6675L15.5 11.7017V16.5C15.5 16.96 15.1267 17.3333 14.6667 17.3333H1.33333C0.873333 17.3333 0.5 16.96 0.5 16.5V1.49999C0.5 1.03999 0.873333 0.666656 1.33333 0.666656H14.6667ZM16.1483 6.33999L17.3267 7.51832L10.845 14L9.665 13.9983L9.66667 12.8217L16.1483 6.33999ZM8 8.99999H3.83333V10.6667H8V8.99999ZM10.5 5.66666H3.83333V7.33332H10.5V5.66666Z" fill="currentColor"/>
            </svg>
        </IconButton>
    )
}

export { SupportIcon };